<template lang='pug'>
div
  slot(
    :prop='prop'
    :timestamp='timestamp'
    :updateProp='updateProp'
    :updateTimestamp='updateTimestamp'
  )
</template>

<script>
import { useEventToProp } from '../functions/useEventToProp';

const setup = (props, ctx) =>
{
  const {
    prop,
    propUpdate,
    timestamp,
    timestampUpdate: updateTimestamp,
  } = useEventToProp();

  const updateProp = prop =>
  {
    ctx.emit('update:prop', propUpdate(prop));

    return prop;
  };

  return {
    prop,
    updateProp,
    timestamp,
    updateTimestamp,
  };
};

export default
{
  setup
};
</script>